import React, { useCallback } from 'react'
import { replace } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import { findAll } from 'highlight-words-core'

import { facilityNewRequest } from '../../../actions/facilitiesActions'

const highlightable = ({ text, query }) => {
  if (query === null || query === undefined || query === '' || query.length < 3) {
    return false
  }
  return (
    findAll({ textToHighlight: text, searchWords: query.match(/"[^"]+"|\S+/g) }).find(chunk => chunk.highlight) !==
    undefined
  )
}

export const Facilities = () => {
  const dispatch = useDispatch()

  const facilities = useSelector(store => store.facilities.facilities)
  const query = useSelector(store => store.facilities.query)

  const matchingLoops = useCallback(
    facility => Object.keys(facility.sites_details?.loops).filter(loop => highlightable({ text: loop, query })),
    [query]
  )

  const handleClick = facility => dispatch(facilityNewRequest(facility))

  return (
    <>
      <h2 className="text-xl font-semibold border-b-2 border-green-500 mb-4">Top Results</h2>
      {facilities.map(facility => (
        <div
          key={facility.id}
          data-id={facility.id}
          className="flex justify-between pt-2 pb-2 mb-4 border-b border-gray-300 cursor-pointer"
          onClick={() => handleClick(facility)}
        >
          <div className="">
            <div className="text-2xl font-semibold">{facility.name}</div>
            <div className="text-sm text-gray-400">{facility.sub_name}</div>
            {facility.out_of_order && (
              <div className="font-semibold text-lg text-red-800 pl-2">
                Reservations unavailable: {facility.out_of_order_reason}
              </div>
            )}

            {matchingLoops(facility).length > 0 && (
              <div className="mt-2">
                {matchingLoops(facility).map((loop, i) => (
                  <div key={loop} className="text-xl">
                    {loop}
                  </div>
                ))}
              </div>
            )}
          </div>
          <FontAwesomeIcon icon={faArrowCircleRight} className="flex text-5xl text-green-600" />
        </div>
      ))}
    </>
  )
}

export default Facilities
